/* eslint-disable react/jsx-no-target-blank */
import { css } from '@emotion/react'
import {
    Header,
    Footer,
    PageHeader,
    FeatureCard,
    TeamMember,
    AutoCounter,
    Title
} from '../components/shared'
import { gql } from '@apollo/client'
import { createServerApolloClient } from '../dsl/client'
import { mapValues, keyBy } from 'lodash'
import Image from 'next/image'
import { StaticDataProvider } from '../hooks/staticData'

import count1 from '../components/shared/icons/count1.svg'
import count2 from '../components/shared/icons/count2.svg'
import count3 from '../components/shared/icons/count3.svg'
import count4 from '../components/shared/icons/count4.svg'
import laserSvg from '../components/shared/icons/048-laser.svg'
import planSvg from '../components/shared/icons/004-plan.svg'
import cargoSvg from '../components/shared/icons/025-cargo.svg'
import weldSvg from '../components/shared/icons/017-weld.svg'

export default function About({ staticData = {} }) {
    return (
        <StaticDataProvider data={staticData}>
            <div dir="rtl">
                <Header />
                <PageHeader
                    title="درباره ما"
                    img_path="/img/bg/about-header.jpg"
                    breadcrumb={['خانه', 'درباره ما']}
                />
                {/* end of header */}
                <section className="relative px-4 lg:px-28 2xl:px-60 pb-10">
                    <Title>درباره باریستا</Title>
                    <div className="grid lg:grid-cols-2 lg:gap-20 ">
                        <p className="text-gray-silver text-justify 2xl:text-base">
                            {staticData?.about?.content}
                        </p>
                        <div className="object-cover w-full max-h-80">
                            <Image
                                width="600"
                                height="300"
                                alt="درباره باریستا"
                                src="/img/contents/about-content.jpg"
                            />
                        </div>
                    </div>
                </section>
                {/* end of section 2 */}
                <section className="px-4 lg:px-28 2xl:px-60 pb-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-6 ">
                        <div
                            className="h-48 mb-10 lg:mb-0"
                            css={css`
                                background-image: url('/img/contents/about-bg-2.png');
                            `}
                        >
                            <div className="p-6">
                                <h2 className="text-white text-lg 2xl:text-xl mb-3">
                                    ماموریت ما
                                </h2>{' '}
                                <p className="text-white 2xl:text-base">
                                    گروه صنعتی باریستا پیشتازدر زمینه طراحی
                                    مهندسی و ساخت صنعتی انواع سازه های فلزی در
                                    ایران است. این مجموعه با بکارگیری از فناوری
                                    روز جهان و تکیه بر نیروی انسانی متخصص و مجرب
                                    ایرانی توانسته است طیف گسترده ای ار تولید
                                    صنعتی اسکلت های فولادی را ارایه نماید.
                                </p>
                            </div>{' '}
                        </div>
                        <div
                            className="h-48"
                            css={css`
                                background-image: url('/img/contents/about-bg-1.png');
                            `}
                        >
                            <div className="p-6">
                                <h2 className="text-white text-lg 2xl:text-xl mb-3">
                                    ماموریت ما
                                </h2>{' '}
                                <p className="text-white 2xl:text-base">
                                    گروه صنعتی باریستا پیشتازدر زمینه طراحی
                                    مهندسی و ساخت صنعتی انواع سازه های فلزی در
                                    ایران است. این مجموعه با بکارگیری از فناوری
                                    روز جهان و تکیه بر نیروی انسانی متخصص و مجرب
                                    ایرانی توانسته است طیف گسترده ای ار تولید
                                    صنعتی اسکلت های فولادی را ارایه نماید.
                                </p>
                            </div>{' '}
                        </div>
                    </div>
                </section>
                <section
                    className="relative lg:px-28 2xl:px-60 bg-gray-cultured pb-20 2xl:text-base"
                    css={css`
                        background-image: url(/media/img/fname/ویژگی-باریستا-1920-868.jpg);
                        background-size: cover;
                    `}
                >
                    <Title text_color="#d3d3d3">ویژگی های باریستا</Title>

                    <div className="grid md:grid-cols-2 xl:grid-cols-4 justify-items-center text-gray-silver px-10">
                        <FeatureCard
                            title="امکان تولید مکانیزه"
                            description="خطوط تولید در کارگاه ها و کارخانجات تولیدی و صنعتی اصلی ترین و تاثیر گذار ترین بخش ها در درآمد این مجموعه ها هستند."
                            icon={laserSvg}
                        />
                        <FeatureCard
                            title="سازه مصنوعی"
                            description="با استفاده از هوش مصنوعی و الگوریتم‌های فراابتکاری
                        موفق به تولید نرم‌افزار بهینه‌سازی سازه‌ها شده است"
                            icon={planSvg}
                        />
                        <FeatureCard
                            title="کیفیت مواد اولیه"
                            description="یکی از پیش‌شرط‌های مهم تولید محصول، تامین مواد اولیه
                        با کیفیت است که با استفاده از دانش فنی بالا رقم
                        می‌خورد."
                            icon={cargoSvg}
                        />
                        <FeatureCard
                            title="حذف جوشکاری"
                            description="جوشکاری زیر پودری به طور گسترده در صنایع نفت و گاز و ساخت مخازن ذخیره، مخازن تحت فشار، کشتی سازی و... استفاده می گردد. "
                            icon={weldSvg}
                        />
                    </div>
                </section>
                <section className="relative px-4 lg:px-28 2xl:px-60 pb-10">
                    <Title> تیم باریستا</Title>
                    <p className="2xl:text-base text-gray-silver mb-10">
                        {' '}
                        تیم باریستا یکی از مجرب ترین تیم های طراحی ، ساخت و اجرا
                        در ایران میباشد
                    </p>
                    <div className="grid  gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                        <TeamMember
                            img="/img/contents/team-1.jpg"
                            name="اشکان توتونچی"
                            description="مدیریت"
                        />
                        <TeamMember
                            img="/img/contents/team-2.jpg"
                            name="علی ایمانی"
                            description="مهندس ناظر"
                        />
                        <TeamMember
                            img="/img/contents/team-3.jpg"
                            name="احمد برنا"
                            description="دیجیتال مارکتینگ"
                        />
                        <TeamMember
                            img="/img/contents/team-4.jpg"
                            name="سینا دبیر"
                            description="منابع انسانی"
                        />
                    </div>
                </section>
                <section className="px-4 lg:px-28 2xl:px-60 pb-10 bg-gray-cultured relative">
                    <Title> آمار و رزومه باریستا</Title>
                    <div className="grid grid-cols-1 md:grid-cols-3 ">
                        <p className="2xl:text-base text-gray-silver col-span-2 text-justify">
                            {' '}
                            گروه مهندسی باریستا، با مشورت و همکاری با بهترین
                            مهندسین مشاور مطرح در ایران ، بهترین راهکارهای ساخت
                            سازه را برای ساخت سازه شمابا استفاده از روز ترین نرم
                            افزارهای مودلینگ، بررسی، و بهترین نقشه سازه را با در
                            نظر گرفتن خواسته های کارفرما، بهینه سازی بیشترین
                            فضای مفید و کمترین هزین.{' '}
                        </p>
                        <div className="flex item-center mt-4 md:mt-0 justify-center">
                            <a
                                className=" py-4 px-4 w-1/2 md:w-2/3 lg:w-40 bg-black-rich text-lg text-center text-white h-16 md:mr-auto  "
                                href={`/api/storage/${staticData.resume?.metas?.attachment?.hash}`}
                                download="bareesta-cv.pdf"
                                target="_blank"
                            >
                                {staticData.resume.content}
                            </a>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-10 lg:gap-4 xl:gap-10 mx-auto xl:px-20 2xl:px-40 px-10 mt-10">
                        <AutoCounter
                            bg="/img/bg/asset-4.png"
                            icon={count1}
                            number="2000"
                            description="نفرات استفاده شده"
                        />
                        <AutoCounter
                            bg="/img/bg/asset-1.png"
                            icon={count2}
                            number="2000"
                            description="نفرات استفاده شده"
                        />
                        <AutoCounter
                            bg="/img/bg/asset-2.png"
                            icon={count3}
                            number="2000"
                            description="نفرات استفاده شده"
                        />
                        <AutoCounter
                            bg="/img/bg/asset-3.png"
                            icon={count4}
                            number="2000"
                            description="نفرات استفاده شده"
                        />
                    </div>
                </section>
                {/* <section className="px-4 lg:px-28 2xl:px-60 pb-10 bg-gray-silver relative h-96"> */}
                {/* {data?.entities?.map((e) => (
                    <div key={e.id}>{e.title}</div>
                ))} */}
                {/* {console.log('data on server', data)} */}
                {/* </section> */}

                <Footer />
            </div>
        </StaticDataProvider>
    )
}

export async function getStaticProps() {
    // const productsQuery = gql`
    //     ${documentsFragment}
    //     query AboutData {
    //         documents {
    //             entities {
    //                 ...ProductFields
    //             }
    //         }
    //     }
    // `
    const query = gql`
        query ($keys: [String]) {
            staticData: documents(
                search: {
                    type: { values: ["setting"], type: EXACT }
                    name: { values: $keys, type: EXACT }
                }
                meta: { limit: 20 }
            ) {
                entities {
                    name
                    content
                    metas
                }
            }
            # data: documents(
            #     search: {type: { values: ["product"], type: EXACT }}
            # ) {
            #         entities {

            #         }
            #     }
        }
    `
    const client = createServerApolloClient()
    const settingKeys = [
        'about_footer',
        'email',
        'work_time',
        'head_tel',
        'tel',
        'addr',
        'head_sub',
        'head_sub',
        'about_home',
        'resume',
        'catalog',
        'about'
    ]
    const { data } = await client.query({
        query: query,
        variables: { keys: settingKeys }
    })
    const staticData = mapValues(
        keyBy(data?.staticData?.entities, 'name'),
        (i) => i
    )

    return {
        props: {
            staticData
        },
        revalidate: 60
    }

    // const { data } = await client.query({
    //     query: productsQuery
    // })
    // console.log('data on server', data)
    // return {
    //     props: {
    //         data
    //     }
    // }
}
